import React, { useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Button } from 'components/Button';
import { Input } from 'components/Input';
import { AuthInput } from 'components/AuthInput/AuthInput';
import { userApi } from 'helpers/api/user';

export const PasswordResetConfirmForm = ({ pending, onSubmit }) => {
  const [password, setPassword] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');

  const handlePassword = (value) => setPassword(value);
  const handlePasswordRepeat = (value) => setPasswordRepeat(value);

  const handleSubmit = (e) => {
    if (pending) {
      return;
    }

    onSubmit({
      password,
      passwordRepeat,
    });
  };

  return (
    <div className="login-block">
      <div className="login-block-title">Создайте новый пароль</div>

      <div className="login-block-container">
        <form>
          <Input
            type="password"
            placeholder="Введите пароль"
            value={password}
            onChange={handlePassword}
            required={true}
          />
          <Input
            type="password"
            placeholder="Повторите пароль"
            value={passwordRepeat}
            onChange={handlePasswordRepeat}
            required={true}
          />

          <Button
            onClick={handleSubmit}
            className={'btn-form'}
            disabled={pending || !password || !passwordRepeat}
            loader={pending}
          >
            Сохранить пароль
          </Button>
        </form>
      </div>
    </div>
  );
};
